import ModalPanel from '@admin/components/modal_panel'
import Message from '@admin/components/message'
import PropTypes from 'prop-types'
import React from 'react'

class Success extends React.Component {

  static propTypes = {
    title: PropTypes.string,
    onDone: PropTypes.func
  }

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <Message { ...this._getSuccess() } />
      </ModalPanel>
    )
  }

  _getPanel() {
    const { title } = this.props
    return {
      title
    }
  }

  _getSuccess() {
    return {
      title: 't(Request Completed)',
      text: 't(Your request was successfully completed)',
      svg: 'check',
      color: 'green',
      animation: 'tada',
      button: {
        label: 't(Finish)',
        handler: this.props.onDone
      }
    }
  }

}

export default Success
